import { render, staticRenderFns } from "./ColorPreviewPR.vue?vue&type=template&id=2c994b32&scoped=true&"
import script from "./ColorPreviewPR.vue?vue&type=script&lang=js&"
export * from "./ColorPreviewPR.vue?vue&type=script&lang=js&"
import style0 from "./ColorPreviewPR.vue?vue&type=style&index=0&id=2c994b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c994b32",
  null
  
)

export default component.exports